import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const PricingPage = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-saverly-primary/10 to-saverly-deep/10 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-saverly-dark font-poppins mb-6">
            Simple, Transparent
            <span className="block text-saverly-primary">Pricing</span>
          </h1>
          <p className="text-xl text-saverly-gray font-inter max-w-3xl mx-auto">
            Choose the plan that fits your household. Start free, upgrade when you're ready.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            
            {/* Free Plan */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-200">
              <h3 className="text-2xl font-bold text-saverly-dark font-poppins mb-2">Free</h3>
              <div className="mb-6">
                <span className="text-5xl font-bold text-saverly-dark">$0</span>
                <span className="text-saverly-gray">/month</span>
              </div>
              <p className="text-saverly-gray mb-6">Perfect for trying out Saverly</p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">5 sales-powered recipes per week</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">18 dietary preferences (Vegan, Keto, etc.)</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Complete meals with sides and vegetables</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Automatic product matching</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Detailed nutrition information*</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Browse live sales from Kroger stores</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Smart shopping lists</span>
                </li>
              </ul>

              <p className="text-xs text-gray-500 mb-6">*When available from retailer</p>

              <Link to="/download">
                <Button className="w-full bg-gray-900 hover:bg-gray-800 text-white py-3 rounded-xl font-semibold">
                  Start Free
                </Button>
              </Link>
            </div>

            {/* Pro Plan - Most Popular */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border-4 border-saverly-primary relative">
              <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <span className="bg-saverly-primary text-white px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </span>
              </div>
              
              <h3 className="text-2xl font-bold text-saverly-dark font-poppins mb-2">Pro</h3>
              <div className="mb-6">
                <span className="text-5xl font-bold text-saverly-primary">$4.99</span>
                <span className="text-saverly-gray">/month</span>
                <p className="text-sm text-saverly-gray mt-2">$49.99/year</p>
              </div>
              <p className="text-saverly-gray mb-6">Unlimited sales-powered recipes for regular planners</p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700 font-semibold">Unlimited sales-powered recipes</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700 font-semibold">Import your own recipes</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Everything in Free plan</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Priority support</span>
                </li>
              </ul>

              <p className="text-sm text-center text-saverly-gray mb-6">
                Upgrade anytime for unlimited meals
              </p>

              <Link to="/checkout">
                <Button className="w-full bg-saverly-primary hover:bg-saverly-primary-dark text-white py-3 rounded-xl font-semibold">
                  Go Unlimited
                </Button>
              </Link>
            </div>

            {/* Family Plan */}
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-200 relative">
              <h3 className="text-2xl font-bold text-saverly-dark font-poppins mb-2">Family</h3>
              <div className="mb-6">
                <span className="text-5xl font-bold text-saverly-dark">$6.99</span>
                <span className="text-saverly-gray">/month</span>
                <p className="text-sm text-saverly-gray mt-2">$69.99/year</p>
              </div>
              <p className="text-saverly-gray mb-6">Share Saverly with your household</p>
              
              <ul className="space-y-3 mb-8">
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Everything in Pro</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Up to 5 family members</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Shared lists and recipes</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Collaborative meal planning</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 text-saverly-primary mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  <span className="text-gray-700">Priority support</span>
                </li>
              </ul>

              <Link to="/download">
                <Button className="w-full bg-saverly-deep hover:bg-saverly-deep/90 text-white py-3 rounded-xl font-semibold">
                  Start Family Plan
                </Button>
              </Link>
            </div>

          </div>
        </div>
      </section>


      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-saverly-dark font-poppins mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-saverly-gray font-inter">
              Everything you need to know about our pricing.
            </p>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                How does the free plan work?
              </h3>
              <p className="text-saverly-gray font-inter">
                The free plan gives you access to all Saverly features including dietary preferences, complete meal planning, automatic product matching, and nutrition information. The only limit is 5 sales-powered recipes per week. No credit card required to start. Upgrade to Pro or Family anytime for unlimited meal generation.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                Can I change my plan later?
              </h3>
              <p className="text-saverly-gray font-inter">
                Absolutely! You can upgrade or downgrade your plan at any time. Changes take effect immediately, and we'll prorate any differences.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                What stores does Saverly support?
              </h3>
              <p className="text-saverly-gray font-inter">
                Currently, Saverly is integrated with Kroger family stores (Kroger, Fry's, Ralph's, King Soopers, Smith's, and more). We're working on adding more retailers in the future.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                How does the sales-powered meal planner work?
              </h3>
              <p className="text-saverly-gray font-inter">
                Our AI (powered by OpenAI) generates complete meal plans based on products you select and your dietary preferences. Each meal includes a main dish, sides, vegetables, and all necessary ingredients (typically 10-20 items), which are automatically matched to products available at your local Kroger family store.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                Can I import my own recipes?
              </h3>
              <p className="text-saverly-gray font-inter">
                Yes! Pro and Family subscribers can import their own recipes by simply pasting recipe text from any website or cookbook. Our AI will automatically parse the ingredients and instructions, then match all ingredients to products at your local Kroger store. It's perfect for using your favorite family recipes while still taking advantage of Saverly's smart shopping features.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                Are the prices shown accurate?
              </h3>
              <p className="text-saverly-gray font-inter">
                We display real-time prices from Kroger's API, but prices may vary by location and can change. Always verify prices at checkout.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-saverly-primary to-saverly-accent text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold font-poppins mb-6">
            Ready to Start Saving?
          </h2>
          <p className="text-xl text-white font-inter mb-8">
            Join thousands of families saving time and money with sales-powered meal planning.
          </p>
          <Link to="/download">
            <Button size="lg" className="bg-white text-saverly-primary hover:bg-gray-100 px-8 py-4 text-lg font-semibold rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105">
              Get Started Free
            </Button>
          </Link>
          <p className="text-sm text-white mt-4">No credit card required • Free forever</p>
        </div>
      </section>
    </div>
  );
};

export default PricingPage; 